var map = {
	"./add-course-1.jpg": 54171,
	"./course-01.jpg": 1951,
	"./course-01.svg": 7433,
	"./course-02.jpg": 87600,
	"./course-02.svg": 22970,
	"./course-03.jpg": 39821,
	"./course-03.svg": 53931,
	"./course-04.jpg": 20742,
	"./course-04.svg": 49252,
	"./course-05.jpg": 80227,
	"./course-06.jpg": 34164,
	"./course-07.jpg": 48497,
	"./course-08.jpg": 77386,
	"./course-09.jpg": 33223,
	"./course-10.jpg": 68825,
	"./course-11.jpg": 24476,
	"./course-12.jpg": 49643,
	"./course-13.jpg": 70158,
	"./course-14.jpg": 7221,
	"./course-15.jpg": 46040,
	"./course-16.jpg": 78887,
	"./course-17.jpg": 83082,
	"./course-18.jpg": 45137,
	"./course-19.jpg": 31412,
	"./course-20.jpg": 12296,
	"./course-21.jpg": 39909,
	"./course-22.jpg": 82682,
	"./course-23.jpg": 34615,
	"./course-24.jpg": 74380,
	"./course-25.jpg": 88521,
	"./course-26.jpg": 97022,
	"./course-27.jpg": 17179,
	"./course-28.jpg": 91872,
	"./course-29.jpg": 43613,
	"./course-30.jpg": 6151,
	"./course-31.jpg": 38410,
	"./course-32.jpg": 30485,
	"./course-33.jpg": 26168,
	"./course-34.jpg": 72907,
	"./course-35.jpg": 94862,
	"./course-36.jpg": 75129,
	"./course-37.jpg": 88252,
	"./course-38.jpg": 32351,
	"./course-39.jpg": 24290,
	"./course-40.jpg": 85198,
	"./course-41.jpg": 63243,
	"./course-42.jpg": 78588,
	"./course-43.jpg": 65465,
	"./course-44.jpg": 28746,
	"./course-45.jpg": 96487,
	"./course-46.jpg": 16504,
	"./course-47.jpg": 20821,
	"./course-48.jpg": 84006,
	"./course-bg-1.svg": 2163,
	"./course-bg-2.png": 14990,
	"./course-bg-2.svg": 11424,
	"./course-bg-3.svg": 68337,
	"./course-details-bg.jpg": 93748,
	"./course-details-two-1.jpg": 46449,
	"./course-details-two-2.jpg": 14246,
	"./courses-01.jpg": 42538,
	"./courses-02.jpg": 9877,
	"./courses-03.jpg": 2616,
	"./courses-04.jpg": 25451,
	"./courses-05.jpg": 98990,
	"./courses-06.jpg": 55129,
	"./featured-course-01.jpg": 32356,
	"./featured-course-02.jpg": 16051,
	"./featured-course-03.jpg": 60790,
	"./featured-course-04.jpg": 1309,
	"./featured-course-05.jpg": 92096,
	"./featured-course-06.jpg": 58735,
	"./video-bg.jpg": 48335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44654;